// removed by extract-text-webpack-plugin
module.exports = {"sortBy":"SortBy__sortBy___2MRoI","label":"SortBy__label___3OsAZ","input":"SortBy__input___1KGcn","popup":"SortBy__popup___zQWX6"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/employer/projectInformation/components/candidates/SortBy.scss
// module id = 1948
// module chunks = 0